import Api from './Api';

class LogicBaseRelationshipApi extends Api {
  url = 'logicbaserelationships';
}

const singleton = new LogicBaseRelationshipApi();
export default singleton;
